import {createContext, use, type ReactNode} from 'react'

/**
 * Optional footer rendered by the nearest `Tool` frame inside its bordered content box.
 * Without a provider the frame renders exactly as before.
 */
export const ToolFooterSlotContext = createContext<ReactNode>(undefined)

export function useToolFooterSlot(): ReactNode {
  return use(ToolFooterSlotContext)
}
